import compose from 'ramda/src/compose'
import mergeLeft from 'ramda/src/mergeLeft'
import over from 'ramda/src/over'
import lensPath from 'ramda/src/lensPath'
import { UPDATE_PROJECT_RECORD } from 'root/src/client/logic/project/actionIds'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { setRecordProcessingChild } = apiStoreLenses

export default {
	[UPDATE_PROJECT_RECORD]: (state, record) => {
		const { id } = record
		return compose(
			over(lensPath(['api', 'records', 'project', id]), mergeLeft(record)),
			setRecordProcessingChild(id, false),
		)(state)
	},
}
